import { render, staticRenderFns } from "./Panel.global.vue?vue&type=template&id=2525cca9&scoped=true&lang=pug&"
import script from "./Panel.global.vue?vue&type=script&lang=ts&"
export * from "./Panel.global.vue?vue&type=script&lang=ts&"
import style0 from "./Panel.global.vue?vue&type=style&index=0&id=2525cca9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2525cca9",
  null
  
)

export default component.exports